module.exports = __webpack_public_path__ + "static/media/apple_iphone.d72131bd.jpg";